export const HARVEST_EVENTS_LOAD_REQUESTED = 'HARVEST_EVENTS_LOAD_REQUESTED';
export const HARVEST_EVENTS_LOAD_SUCCEEDED = 'HARVEST_EVENTS_LOAD_SUCCEEDED';
export const HARVEST_EVENTS_LOAD_FAILED = 'HARVEST_EVENTS_LOAD_FAILED';
export const HARVEST_EVENTS_LOAD_CANCELED = 'HARVEST_EVENTS_LOAD_CANCELED';

export const HARVEST_EVENTS_SAVE_REQUESTED = 'HARVEST_EVENTS_SAVE_REQUESTED';
export const HARVEST_EVENTS_SAVE_SUCCEEDED = 'HARVEST_EVENTS_SAVE_SUCCEEDED';
export const HARVEST_EVENTS_SAVE_FAILED = 'HARVEST_EVENTS_SAVE_FAILED';

export const HARVEST_EVENT_UPDATE = 'HARVEST_EVENT_UPDATE';
export const HARVEST_EVENTS_UPDATE = 'HARVEST_EVENTS_UPDATE';
export const HARVEST_EVENT_VALUE_UPDATE = 'HARVEST_EVENT_VALUE_UPDATE';
export const HARVEST_EVENTS_VALUE_UPDATE = 'HARVEST_EVENTS_VALUE_UPDATE';
export const HARVEST_EVENT_REMOVE = 'HARVEST_EVENT_REMOVE';
export const HARVEST_EVENTS_UPDATES_PURGE = 'HARVEST_EVENTS_UPDATES_PURGE';

export const HARVEST_EVENT_SET = 'HARVEST_EVENT_SET';
export const HARVEST_EVENTS_SET = 'HARVEST_EVENTS_SET';
export const HARVEST_EVENTS_MERGE = 'HARVEST_EVENTS_MERGE';
export const HARVEST_EVENTS_DELETE = 'HARVEST_EVENTS_DELETE';
export const HARVEST_EVENT_BULK_DELETE = 'HARVEST_EVENT_BULK_DELETE';
export const HARVEST_EVENTS_ERRORS_SET = 'HARVEST_EVENTS_ERRORS_SET';

export const HARVEST_EVENT_TIMELINE_UPDATE = 'HARVEST_EVENT_TIMELINE_UPDATE';
export const HARVEST_EVENT_TIMELINE_UNDO = 'HARVEST_EVENT_TIMELINE_UNDO';
